import * as React from "react";
import * as url from "url";
// components
import { EmbeddedVideo as EmbeddedVideoStyle } from "./styledComponents";
import BlurhashCanvas from "common/components/blurHash";
// helpers
import Icon from "common/icons";
import PACKS from "common/icons/packs";

const Blurhash = EmbeddedVideoStyle.BlurHashWrapper.withComponent(
  BlurhashCanvas,
);

const EmbeddedVideo = ({
  block,
  withFooter = true,
}: {
  block: Vingle.IEmbeddedVideo;
  withFooter?: boolean;
}) => {
  const urlObject = url.parse(block["embed-url"]);
  const host = urlObject.hostname;
  const extraParameter = `${urlObject.query ? "&" : "?"}playsinline=1`;

  let footer;
  if (withFooter) {
    footer = (
      <EmbeddedVideoStyle.Footer target="_blank" href={block.src}>
        <EmbeddedVideoStyle.Host>{`${host}`}</EmbeddedVideoStyle.Host>
        <Icon icon={PACKS.LINKPREVIEW_ARROW} />
      </EmbeddedVideoStyle.Footer>
    );
  } else {
    footer = null;
  }

  return (
    <EmbeddedVideoStyle.Wrapper>
      <EmbeddedVideoStyle.Figure>
        <EmbeddedVideoStyle.IFrame
          src={`${block["embed-url"].replace(/^https?:/, "")}${extraParameter}`}
          frameBorder={0}
          allow="autoplay"
        />
        <Blurhash
          className="placeholder"
          hash={block.blur_hash}
          width={block.width}
          height={block.height}
          style={{
            backgroundColor: block["preview-color"],
          }}
        />
      </EmbeddedVideoStyle.Figure>
      {footer}
    </EmbeddedVideoStyle.Wrapper>
  );
};

export default EmbeddedVideo;
